module.exports = __webpack_public_path__ + "img/10.022c1d4d.png";